/* eslint-disable vue/valid-v-bind */
<template>
    <sequential-entrance :delay="delay" :animation="animation">
        <RadioOption
            v-for="(item, index) in items"
            :key="index"
            :index="index"
            :id="item.id"
            :optionType="optionType"
            :class="{active: item.id === activatedId}"
            :activatedId="activatedId"
            :icon="item.icon"
            :name="item.name"
            :suggestion="suggestions ? suggestions[index] : null"
            :spanProp="spanProp"
            @change="onChange"
            @mouseenter.native="onMouseHover(item.id)"
            @mouseleave.native="onMouseLeave"
        >
          <template v-if="suggestions" #suggestion>
            <p v-if="index===0">年齡性別：18-55+歲、男性/女性/全部</p>
            <p v-if="index===1">分析特定產業的<HpcSuggestion placement="bottom"></HpcSuggestion>之輪廓樣貌，並鎖定相似輪廓的受眾</p>
            <p v-if="index===2">依據消費者的網海行為貼標(閱覽興趣、造訪網站類型...etc)，當某一類型之標籤達到一定濃度時，則將之分群至所屬族群</p>
          </template>
        </RadioOption>
        <el-col v-if="showInfo" :span="24">
            <div style="">
                <a href="" class="option_item_other" style=""  >{{showInfo.txt}}</a>
            </div>
        </el-col>
    </sequential-entrance>
</template>

<script>
import RadioOption from './RadioOption'
import HpcSuggestion from '@/views/HpcSuggestion'

export default {
  name: 'RadioGroup',
  props: ['items', 'activatedId',
    'delay', 'animation',
    'optionType', 'showInfo',
    'suggestions', 'spanProp', 'toggleMouseInOutMethod'],
  components: {
    HpcSuggestion,
    RadioOption
  },
  methods: {
    onChange (index) {
      const item = this.items[index]
      if (item) {
        this.$emit('change', item)
      }
    },
    onMouseHover (itemId) {
      if (!this.toggleMouseInOutMethod) return
      this.$emit('hoverItem', itemId)
    },
    onMouseLeave () {
      if (!this.toggleMouseInOutMethod) return
      this.$emit('leaveItem')
    }
  }
}
</script>

<style scoped>

</style>
